// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607230034/js/" + chunkId + "." + {"44":"113ac94f","225":"e130930e","481":"b9a56213","486":"ce6ce893","770":"2c378da5"}[chunkId] + ".0.6348389592893234.chunk.js";
};